import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=d0a71d7a&scoped=true&"
import script from "./customers.vue?vue&type=script&lang=js&"
export * from "./customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a71d7a",
  null
  
)

export default component.exports